export default {
  state: {
    userData: {},
  },

  getters: {
    getUserData(state) {
      return state.userData;
    },
  },

  mutations: {
    setUserData(state, data) {
      const isNull = data === null;

      state.userData = {
        id: !isNull ? data.id : 0,
        name: !isNull ? data.name : "",
        email: !isNull ? data.email : "",
        cpf: !isNull ? data.cpf : "",
        profile_id: !isNull ? parseInt(data.profile.id) : "",
        city: !isNull ? data.city : "",
        instituitionId: !isNull ? parseInt(data.instituitionId) : "",
        instituition: !isNull ? data.instituition : null,
        regional: !isNull ? data.regional : "",
      };
    },

    setRegion(state, data) {
      state.userData.regional = data;
    },

    setCity(state, data) {
      state.userData.city = data;
    },

    setInstituitionId(state, data) {
      state.userData.instituitionId = data;
    }
  },

  actions: {
    changeUserData(context, infos) {
      context.commit("setUserData", infos);
    },

    changeRegion(context, infos) {
      context.commit("setRegion", infos);
    },

    changeCity(context, infos) {
      context.commit("setCity", infos);
    },

    changeInstituitionId(context, infos) {
      context.commit("setInstituitionId", infos)
    }
  },
};
